import { render, staticRenderFns } from "./admitsPer1000.vue?vue&type=template&id=eb1a2bd4"
import script from "./admitsPer1000.vue?vue&type=script&lang=js"
export * from "./admitsPer1000.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports